const LIVE_DURATION_HOURS_THRESHOLD_SEC = 60 * 60;

export function formatLiveDuration(totalSeconds: number): string {
  const secs = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(secs / 60);
  const seconds = secs % 60;

  if (secs >= LIVE_DURATION_HOURS_THRESHOLD_SEC) {
    const hours = Math.floor(secs / 3600);
    const mins = Math.floor((secs % 3600) / 60);
    return `${hours}h${mins.toString().padStart(2, '0')}m${seconds.toString().padStart(2, '0')}s`;
  }

  return `${minutes.toString().padStart(2, '0')}m${seconds.toString().padStart(2, '0')}s`;
}
